/* tslint:disable */
/* eslint-disable */
/**
 * Compliance
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { ComplianceFileType } from './';
import {
    ComplianceFileTypeFromJSON,
    ComplianceFileTypeFromJSONTyped,
    ComplianceFileTypeToJSON,
} from './';
import type { LegalDetailsTemplate } from './';
import {
    LegalDetailsTemplateFromJSON,
    LegalDetailsTemplateFromJSONTyped,
    LegalDetailsTemplateToJSON,
} from './';
import type { LegalPersonType } from './';
import {
    LegalPersonTypeFromJSON,
    LegalPersonTypeFromJSONTyped,
    LegalPersonTypeToJSON,
} from './';
import type { UserType } from './';
import {
    UserTypeFromJSON,
    UserTypeFromJSONTyped,
    UserTypeToJSON,
} from './';

/**
 * 
 * @export
 * @interface CompanyTypeResource
 */
export interface CompanyTypeResource {
    /**
     * 
     * @type {string}
     * @memberof CompanyTypeResource
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof CompanyTypeResource
     */
    country?: string;
    /**
     * 
     * @type {string}
     * @memberof CompanyTypeResource
     */
    language?: string;
    /**
     * 
     * @type {string}
     * @memberof CompanyTypeResource
     */
    label?: string;
    /**
     * 
     * @type {LegalDetailsTemplate}
     * @memberof CompanyTypeResource
     */
    legalNoticesTemplate?: LegalDetailsTemplate;
    /**
     * 
     * @type {Array<ComplianceFileType>}
     * @memberof CompanyTypeResource
     */
    mandatoryDocuments: Array<ComplianceFileType>;
    /**
     * 
     * @type {UserType}
     * @memberof CompanyTypeResource
     */
    userType?: UserType;
    /**
     * 
     * @type {LegalPersonType}
     * @memberof CompanyTypeResource
     */
    legalPersonType: LegalPersonType;
    /**
     * 
     * @type {boolean}
     * @memberof CompanyTypeResource
     */
    enabled: boolean;
}

/**
 * Check if a given object implements the CompanyTypeResource interface.
 */
export function instanceOfCompanyTypeResource(value: object): value is CompanyTypeResource {
    if (!('mandatoryDocuments' in value) || value['mandatoryDocuments'] === undefined) return false;
    if (!('legalPersonType' in value) || value['legalPersonType'] === undefined) return false;
    if (!('enabled' in value) || value['enabled'] === undefined) return false;
    return true;
}

export function CompanyTypeResourceFromJSON(json: any): CompanyTypeResource {
    return CompanyTypeResourceFromJSONTyped(json, false);
}

export function CompanyTypeResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): CompanyTypeResource {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'country': json['country'] == null ? undefined : json['country'],
        'language': json['language'] == null ? undefined : json['language'],
        'label': json['label'] == null ? undefined : json['label'],
        'legalNoticesTemplate': json['legalNoticesTemplate'] == null ? undefined : LegalDetailsTemplateFromJSON(json['legalNoticesTemplate']),
        'mandatoryDocuments': ((json['mandatoryDocuments'] as Array<any>).map(ComplianceFileTypeFromJSON)),
        'userType': json['userType'] == null ? undefined : UserTypeFromJSON(json['userType']),
        'legalPersonType': LegalPersonTypeFromJSON(json['legalPersonType']),
        'enabled': json['enabled'],
    };
}

export function CompanyTypeResourceToJSON(value?: CompanyTypeResource | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'country': value['country'],
        'language': value['language'],
        'label': value['label'],
        'legalNoticesTemplate': LegalDetailsTemplateToJSON(value['legalNoticesTemplate']),
        'mandatoryDocuments': ((value['mandatoryDocuments'] as Array<any>).map((v) => ComplianceFileTypeToJSON(v))),
        'userType': UserTypeToJSON(value['userType']),
        'legalPersonType': LegalPersonTypeToJSON(value['legalPersonType']),
        'enabled': value['enabled'],
    };
}

